import axios from "axios";

// Action types
export const SET_ONE_POINT_FIVE_VCP = "SET_ONE_POINT_FIVE_VCP";
export const FETCH_ONE_POINT_FIVE_VCP_START = "FETCH_ONE_POINT_FIVE_VCP_START";
export const FETCH_ONE_POINT_FIVE_VCP_SUCCESS = "FETCH_ONE_POINT_FIVE_VCP_SUCCESS";
export const FETCH_ONE_POINT_FIVE_VCP_FAILURE = "FETCH_ONE_POINT_FIVE_VCP_FAILURE";

// Action creators
export const setOnePointFiveVcp = (value) => ({
  type: SET_ONE_POINT_FIVE_VCP,
  payload: value
});

export const fetchOnePointFiveVcpStart = () => ({
  type: FETCH_ONE_POINT_FIVE_VCP_START
});

export const fetchOnePointFiveVcpSuccess = (value) => {
  const json = JSON.parse(value);
  return {
    type: FETCH_ONE_POINT_FIVE_VCP_SUCCESS,
    payload: json
  };
};

export const fetchOnePointFiveVcpFailure = (error) => ({
  type: FETCH_ONE_POINT_FIVE_VCP_FAILURE,
  payload: error
});

// Thunk action to fetch the setting
export const fetchOnePointFiveVcp = () => {
  return async (dispatch) => {
    dispatch(fetchOnePointFiveVcpStart());
    
    try {
      // URL encode the key to handle special characters
      const encodedKey = encodeURIComponent("1.5 * VCP");
      const response = await axios.get(`/settings/${encodedKey}`);
      
      if (response.status === 200) {
        const setting = response.data;
        dispatch(fetchOnePointFiveVcpSuccess(setting.value));
        return setting.value;
      } else {
        throw new Error("Failed to fetch setting");
      }
    } catch (error) {
      dispatch(fetchOnePointFiveVcpFailure(error.message));
      throw error;
    }
  };
};
